import Centrifuge from 'centrifuge'

import { setInitialWallet } from 'common/billing/wallet/walletActions'
import * as appActions from 'common/core/actions/appActions'
import { bulkActionStatsUpdate } from 'common/core/bulkActions'
import { IAsyncThunkAction, IThunkAction } from 'common/core/interfaces/actions'
import { getCurrentAccount, getUser } from 'common/core/selectors/appSelectors'
import { getMessagingFeatureReview, setInitialSettings } from 'common/settings/actions'
import { getAccountIdFromURL } from 'utils/accountId'
import { trackLastClickedElement } from 'utils/misc'
import {
  accountNotificationsListener,
  anotherTabNotificationsListener,
  wsService,
} from 'utils/services/notificationsService'
import { initializeNotificationsService } from 'utils/services/notificationsService/notificationsService'

import { WebSocketEvents } from './constants/WebSockets'
import * as initApi from './initAppAPI'

/**
 * DISCLAIMER: This action use only on prod
 */
export const updateAppData = (accountId: AccountId) => {
  const fetchData: IAsyncThunkAction<initApi.ResponseData | undefined> = async (dispatch) => {
    if (!accountId) {
      console.warn('Manychat is running in non account-scope environment')
    }

    const data = await initApi.getAppData(accountId)
    if (!data) {
      return
    }

    const walletInfo = data['app.currentAccountWallet'] ?? {}
    await dispatch(setInitialWallet(walletInfo))
    dispatch(setInitialSettings(data))

    dispatch(appActions.setAppData(data))

    return data
  }

  return fetchData
}

export const initializePostRenderingLogic = (): IThunkAction => (dispatch, getState) => {
  const state = getState()
  const accountScopeParams = getCurrentAccount(state)?.notify
  const userScopeParams = getUser(state)?.notify
  wsService.setStore(dispatch, getState)
  initializeNotificationsService(wsService, Centrifuge, accountScopeParams, userScopeParams)

  accountNotificationsListener.on('test', (data) => {
    console.log(data)
  })
  anotherTabNotificationsListener.on(WebSocketEvents.BULK_ACTION_STATUS, (data) => {
    dispatch(bulkActionStatsUpdate(data))
  })
  anotherTabNotificationsListener.on(WebSocketEvents.SUBSCRIBERS_LIST_EXPORT_STATUS, (data) => {
    dispatch(bulkActionStatsUpdate(data))
  })

  trackLastClickedElement()

  const accountId = getAccountIdFromURL()

  if (accountId) dispatch(getMessagingFeatureReview())
}
